import { Injectable } from "@angular/core";
import { AuthProvider } from "../auth/auth";
import { AppConfig } from "../../config/app.config";
import { Product } from "../../models/product";
import { DataProvider } from "../data/data";
import { Sorting, By, Direction } from "../sorting/sorting";
import { Headers, URLSearchParams } from "@angular/http";

const ROUTE = "products";

export interface ProductRequestOptions {
    categoryId?: string;
    textFilter?: string;
    page?: number;
    barcode?: string;
    sort?: Sorting;
}

@Injectable()
export class ProductProvider extends DataProvider<Array<Product>>{

    constructor() {
        super(ROUTE);
    }

    /**
     * Returns list of products with the specified options.
     * @param options Options for paging, filtering and sorting
     */
    public async getProducts(options?: ProductRequestOptions): Promise<Array<Product>> {
        var url;
        if (options) {
            // Prepare url query
            var params = new URLSearchParams();
            if (options.textFilter) {
                params.append('name', options.textFilter);
            } if (options.barcode) {
                params.append('ean', options.barcode);
            } if (options.page != null) {
                params.append('page', options.page.toString());
            } if (options.categoryId != null) {
                url = `categories/${options.categoryId}/` + ROUTE
            } else {
                url = ROUTE;
            } if (options.sort) {
                if (options.sort.by == By.NAME) {
                    if (options.sort.direction == Direction.ASCENDING) {
                        params.append("sort_name", "asc");
                    } else {
                        params.append("sort_name", "desc");
                    }
                } else if (options.sort.by == By.PRICE_INC_VAT) {
                    if (options.sort.direction == Direction.ASCENDING) {
                        params.append("sort_price", "asc");
                    } else {
                        params.append("sort_price", "desc");
                    }
                }
            }
        } else {
            url = ROUTE;
        }
        return this.auth.get(url, new Headers(), params).then(x => {
            x.map(p => this.calculatePriceExcludingVat(p));
            return x;
        });
    }

    /**
     * Returns the product selected 
     * @param uuid Id of product to retrieve from API
     */
    public async getProduct(uuid: string): Promise<Product> {
        return this.auth.get(ROUTE + `/${uuid}`).then(x => {
            if( x ) {
                return this.calculatePriceExcludingVat(x);
            } else {
                return null;
            }
        });
    }

    private calculatePriceExcludingVat(product: Product): Product {
        product.price_excluding_vat = product.price_excluding_vat * 1;
        if (product.vat != null) {
            product.price_including_vat = product.price_excluding_vat * ((+product.vat.value / 100) + 1);
        } else {
            product.price_including_vat = product.price_excluding_vat;
        }

        if (!product.price_excluding_vat || product.price_excluding_vat == 0) {
            product.price_excluding_vat = null;
            product.price_including_vat = null;
        }

        return product;
    }

}




// WEBPACK FOOTER //
// ./src/providers/product/product.ts